import { makeStyles, Theme } from '@material-ui/core/styles'

export const useWebsiteStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        width: '100%',
        backgroundColor: theme.palette.background.default,
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 3),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        gap: theme.spacing(2),
        width: '100%',
        boxSizing: 'border-box',
    },
    headerLeft: {
        minWidth: 0,
        flex: 1,
    },
    headerRight: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        gap: theme.spacing(0.75),
        minWidth: 0,
        flexShrink: 0,
    },
    headerActions: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        gap: theme.spacing(0.75),
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    titleIcon: {
        width: 36,
        height: 36,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.primary.main + '14',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.main,
    },
    pageSubtitle: {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
    },
    liveChip: {
        backgroundColor: '#ecfdf5',
        color: '#15803d',
        fontWeight: 600,
        height: 24,
        '& .MuiChip-label': {
            padding: theme.spacing(0, 1),
        },
    },
    liveDot: {
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: '#22c55e',
        marginRight: theme.spacing(0.5),
    },
    visitLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        color: theme.palette.primary.main,
        fontSize: '0.8rem',
        fontWeight: 500,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    tabsWrapper: {
        padding: theme.spacing(1.5, 3),
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        boxSizing: 'border-box',
    },
    tabs: {
        width: '100%',
        minHeight: 'unset',
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.spacing(1),
        padding: theme.spacing(0.5),
    },
    tab: {
        textTransform: 'none',
        fontSize: '0.875rem',
        fontWeight: 500,
        minHeight: 40,
        minWidth: 0,
        maxWidth: 'none',
        flex: 1,
        borderRadius: theme.spacing(0.75),
        color: theme.palette.text.secondary,
        opacity: 1,
        transition:
            'color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease',
        '&:hover': {
            color: theme.palette.text.primary,
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '&.Mui-selected': {
            color: theme.palette.primary.main,
            fontWeight: 600,
            backgroundColor: theme.palette.primary.main + '18',
            boxShadow: 'none',
        },
        '&.Mui-selected:hover': {
            backgroundColor: theme.palette.primary.main + '24',
        },
    },
    tabLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
    },
    tabIcon: {
        fontSize: 18,
    },
    content: {
        padding: theme.spacing(3),
        width: '100%',
        boxSizing: 'border-box',
    },
    card: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 14,
        boxShadow: '0 2px 10px rgba(26, 45, 55, 0.07)',
    },
    sectionLabel: {
        fontSize: '0.75rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: theme.palette.text.secondary,
    },
    greenTrend: {
        fontSize: '0.625rem',
        fontWeight: 600,
        color: '#16a34a',
    },
    leadChip: {
        backgroundColor: '#ecfdf5',
        color: '#15803d',
        fontWeight: 600,
        fontSize: '0.6875rem',
        height: 22,
    },
}))
